import React, { useState } from 'react';

const LanguageContext = React.createContext();

const LanguageProvider = (props) => {

    const [state, setState] = useState("ES");

    return (
        <LanguageContext.Provider value={[state, setState]}>
            {props.children}
        </LanguageContext.Provider>
    );
}


export { LanguageContext, LanguageProvider };